import { WHATSAPP_PALERMO, WHATSAPP_NUNEZ } from "./constants";

function WhatsAppIcon({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
    </svg>
  );
}

export default function Contact({ t }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32 bg-bn-primary text-bn-bg overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-3 bg-checkered-strong opacity-70" />

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.05]">
        <span className="font-display text-[200px] md:text-[400px] leading-none text-bn-bg whitespace-nowrap">
          NÚÑEZ
        </span>
      </div>

      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
        <p className="font-script text-3xl md:text-4xl text-bn-bg/90 mb-2">{t.contact.kicker}</p>
        <h2
          className="font-display text-bn-bg text-4xl md:text-6xl lg:text-7xl leading-[1] mb-6 text-shadow-vintage"
          data-testid="contact-title"
        >
          {t.contact.title}
        </h2>
        <p className="font-body text-bn-bg/85 text-lg md:text-xl max-w-2xl mx-auto mb-10">
          {t.contact.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={`https://wa.me/${WHATSAPP_PALERMO}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-call-palermo"
            className="inline-flex items-center justify-center gap-3 bg-bn-bg text-bn-primary hover:bg-bn-secondary hover:text-bn-bg px-8 py-5 font-body font-bold text-base md:text-lg uppercase tracking-wider transition-all hover:-translate-y-0.5 shadow-xl"
          >
            <WhatsAppIcon className="w-6 h-6" />
            {t.contact.callPalermo}
          </a>
          <a
            href={`https://wa.me/${WHATSAPP_NUNEZ}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-call-nunez"
            className="inline-flex items-center justify-center gap-3 bg-bn-bg text-bn-primary hover:bg-bn-secondary hover:text-bn-bg px-8 py-5 font-body font-bold text-base md:text-lg uppercase tracking-wider transition-all hover:-translate-y-0.5 shadow-xl"
          >
            <WhatsAppIcon className="w-6 h-6" />
            {t.contact.callNunez}
          </a>
        </div>

        <p className="mt-10 font-script text-2xl text-bn-bg/80">{t.contact.hint}</p>
      </div>
    </section>
  );
}
